import { IonCol, IonGrid, IonRow } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import StarRating from '../common/StarRating';
import { APIData } from '../../common/DataTypes';
import { useLocation } from 'react-router';
import * as ServerAPI from '../../common/ServerAPI';
import { useAppStateAPI } from '../../common/AppStateAPI';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import '@ionic/react/css/ionic-swiper.css';
import { Swiper, SwiperSlide } from 'swiper/react';

const TestimonialSection: React.FC = () => {

    const location = useLocation();
    const { showToastMsg, addProcessingRequests, reduceProcessingRequests } = useAppStateAPI();
    const [testimonials, setTestimonials] = useState<APIData.Testimonial[]>([]);

    useEffect(() => {
        fetchTestimonials();
    }, [location.pathname]);

    const fetchTestimonials = () => {
        addProcessingRequests();
        ServerAPI.getTestimonials().then((response) => {
            if (response?.success) {
                setTestimonials(response.testimonials);
            } else if (response?.message) {
                showToastMsg('error', response?.message);
            } else {
                showToastMsg('error', 'Error occurred while processing the request');
            }
        }).finally(() => {
            reduceProcessingRequests();
        });
    }

    return (
        <div>
            <section className="popular-section white_bg">
                <div className="shape-round">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-10">
                            <h2 className="sec-title text-center">Trusted by 1000+ customers worldwide</h2>
                            <div className="testimonials-content">
                                <Swiper
                                    loop={true}
                                    autoplay={{ delay: 500 }}
                                    pagination={{ clickable: true }}
                                    spaceBetween={20}
                                    breakpoints={{
                                        320: { slidesPerView: 1 },
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 3 },
                                        992: { slidesPerView: 4 },
                                    }}
                                >
                                    {testimonials.map((testimonial, index) => (
                                        <SwiperSlide key={index} className='testimonial_slider'>
                                            <div className="pp-single-slider" style={{ height: "300px" }}>
                                                <div className="single-google-reviews row p-2" style={{ height: "100%", overflowY: "auto", }}>
                                                    <div className="reviews_profile row align-items-center pb-2 text-start">
                                                        <div className="reviews_profile_img">
                                                            <img src="assets/images/home/pro-cat.png" />
                                                        </div>

                                                        <div className="px-2 text-start">
                                                            <div>{testimonial.testimonial_customer_name}</div>

                                                            <div className='text-start mt-3'>
                                                                <StarRating rating={testimonial.testimonial_star_rating} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='reviews_desc'>
                                                        {testimonial.testimonial_description}
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="container my-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <h2 className="text-center fw-bold mb-4">Trusted by 1000+ customers worldwide</h2>

                            <div className="testimonials-content">
                                <Swiper
                                    loop={true}
                                    autoplay={{ delay: 1000 }}
                                    pagination={{ clickable: true }}
                                    spaceBetween={20}
                                    breakpoints={{
                                        320: { slidesPerView: 1 },
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 3 },
                                        992: { slidesPerView: 4 },
                                    }}
                                >
                                    {testimonials.map((testimonial, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="card card-md text-center p-3 shadow-sm overflow-hidden">
                                                
                                                <div className="d-flex align-items-center justify-content-center mb-3">
                                                    <img src="assets/images/home/pro-cat.png"
                                                        className="rounded-circle border"
                                                        style={{ width: "60px", height: "60px", objectFit: "cover" }}
                                                        alt="User"
                                                    />
                                                    <h6 className="fw-bold ms-3 text-uppercase">{testimonial.testimonial_customer_name}</h6>
                                                </div>

                                           
                                                <div className="mb-2">
                                                    <StarRating rating={testimonial.testimonial_star_rating} />
                                                </div>

                                               
                                                <div className="card-body">
                                                    <p className="text-muted small">{testimonial.testimonial_description}</p>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div> */}


            </section>
            {/* <section className="white_bg insta_whole">
                <div className="container-fluid">
                    <div className="col-lg-12 col-md-12">
                        <div className="insta_whole_head">
                            <h4>@venetzmosquitonets</h4>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 float-left">
                        <IonGrid>
                            <IonRow>
                                <IonCol size="12" size-md="4" size-lg="4">
                                    <div className="insta_img">
                                        <img src="assets/images/home/insta1.png" />
                                    </div>
                                </IonCol>
                                <IonCol size="12" size-md="4" size-lg="4">
                                    <div className="insta_img">
                                        <img src="assets/images/home/insta2.png" />
                                    </div>
                                </IonCol>
                                <IonCol size="12" size-md="4" size-lg="4">
                                    <div className="insta_img">
                                        <img src="assets/images/home/insta3.png" />
                                    </div>
                                </IonCol>
                                <IonCol size="12" size-md="4" size-lg="4">
                                    <div className="insta_img">
                                        <img src="assets/images/home/insta4.png" />
                                    </div>
                                </IonCol>
                                <IonCol size="12" size-md="4" size-lg="4">
                                    <div className="insta_img">
                                        <img src="assets/images/home/insta5.png" />
                                    </div>
                                </IonCol>
                                <IonCol size="12" size-md="4" size-lg="4">
                                    <div className="insta_img">
                                        <img src="assets/images/home/insta6.png" />
                                    </div>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </div>
                </div>
            </section> */}
        </div>
    );
};
export default TestimonialSection;